import moment from 'moment';
import Vue from 'vue';

Vue.filter('timeAgo', (date: Date) => moment(date).fromNow());

Vue.filter('formatDate', (date: Date) => moment(date).format('MMM DD, YYYY'));
Vue.filter('formatDateV2', (date: Date) => moment(date).format('DD MMMM YYYY, hh:mm'));
Vue.filter('formatTime', (date: Date) => moment(date).format('hh:mm:ss'));

Vue.filter('capitalize', (value: string) => {
  if (!value) return '';
  return value.toString().charAt(0).toUpperCase() + value.toString().slice(1);
});

Vue.filter('capitalizeAll', (value: string) => {
  if (!value) return '';
  return value
    .toString()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
});

// Sentence-case-ish normalizer for short title-like strings.
// Rules:
//  - first word is capitalized
//  - words with 2+ uppercase letters (acronyms like SDK, iOS) are preserved as-is
//  - the word right after "&" or "and" is capitalized
//  - the word "and" itself is rewritten to "And" (project convention)
//  - everything else is lowercased
Vue.filter('nt', (value: unknown) => {
  if (value == null) return '';
  const s = String(value);
  if (!s) return '';
  const cap = (w: string) => (w ? w.charAt(0).toUpperCase() + w.slice(1) : w);
  const transform = (w: string, i: number, tokens: string[]): string => {
    if (!w) return w;
    const upperCount = (w.match(/[A-Z]/g) || []).length;
    if (upperCount >= 2) return w;
    // numeric magnitude suffixes (5K, 10K, 100M, 1B) — preserve as-is
    if (/^\d+[A-Z]$/.test(w)) return w;
    if (w === '&') return w;
    if (i === 0) return cap(w.toLowerCase());
    const prev = tokens[i - 1];
    if (prev === '&' || prev.toLowerCase() === 'and' || /,$/.test(prev)) return cap(w.toLowerCase());
    if (w.toLowerCase() === 'and') return 'And';
    return w.toLowerCase();
  };
  const words = s.split(/(\s+)/);
  const tokens = words.filter((_, i) => i % 2 === 0);
  const seps = words.filter((_, i) => i % 2 === 1);
  const out = tokens.map((w, i) => transform(w, i, tokens));
  return out.reduce((acc, w, i) => acc + w + (seps[i] || ''), '');
});

Vue.filter('formatPrice', (price: number | string | null | undefined, currency: 'USD' | 'EUR' = 'USD', maximumFractionDigits: number | undefined = undefined) => {
  if (price == null || price === '') return '';
  const num = typeof price === 'string' ? Number(price) : price;
  if (Number.isNaN(num)) return '';
  const opts: Intl.NumberFormatOptions = { style: 'currency', currency };
  if (maximumFractionDigits !== undefined) {
    opts.maximumFractionDigits = maximumFractionDigits;
    opts.minimumFractionDigits = 0;
  }
  return new Intl.NumberFormat('en-US', opts).format(num);
});
